import { format } from "date-fns";
import { ptBR } from "date-fns/locale";

import type { SalesData } from "./types";

// Helper function to format currency
export const formatCurrency = (value: number): string => {
	return new Intl.NumberFormat("pt-BR", {
		style: "currency",
		currency: "BRL",
	}).format(value);
};

// Helper function to format date
export const formatMonthYear = (dateString: string): string => {
	const [year, month] = dateString.split("-");
	return format(new Date(parseInt(year), parseInt(month) - 1), "MMM yyyy", {
		locale: ptBR,
	});
};

// Calculate sales trend
export const calculateTrend = (salesData: SalesData[]): number => {
	if (salesData.length < 2) return 0;

	const lastMonth = salesData[salesData.length - 1].amount;
	const previousMonth = salesData[salesData.length - 2].amount;

	if (previousMonth === 0) return 0;
	return ((lastMonth - previousMonth) / previousMonth) * 100;
};
